export const filter = {
    id: null,
    type_id: null,
    deal_id: null,
    file_path: '',
    text: '',
    created_at: '',
    updated_at: '',         
};